import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { w as waitForAnimation } from './p-rUtJRH95.js';
import { d as defineCustomElement$7 } from './p-7jxIfyyn.js';
import { d as defineCustomElement$6 } from './p-BLpMhFGJ.js';
import { d as defineCustomElement$5 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$4 } from './p-CEvUoLql.js';
import { d as defineCustomElement$3 } from './p-cR96ip-k.js';
import { d as defineCustomElement$2 } from './p-Bn01tsA6.js';

const modalCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;bottom:0;box-sizing:border-box;display:block;font-family:Open Sans;font-size:.875rem;font-weight:400;left:0;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;overflow:auto;position:fixed;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .container{align-items:center;bottom:0;display:flex;justify-content:center;left:0;min-height:100%;pointer-events:none;position:relative;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host .backdrop{background-color:#000000b3;bottom:0;left:0;opacity:0;pointer-events:none;position:fixed;right:0;top:0;transition:opacity .25s ease;z-index:calc(var(--jw-z-index-overlays) - 1)}:host .backdrop.-anim-fade-in{animation:fade-in .25s linear forwards;pointer-events:all}@keyframes fade-in{0%{opacity:0}to{opacity:1}}:host .backdrop.-anim-fade-out{animation:fade-out .25s linear forwards}@keyframes fade-out{0%{opacity:1}to{opacity:0}}:host .content{pointer-events:all;z-index:calc(var(--jw-z-index-overlays) + 1)}.container,.content{padding:2rem}.content{background-color:var(--jw-theme-surface-elevated-default-bg-color);border-color:var(--jw-theme-surface-border-border-color);border-radius:.375rem;box-shadow:var(--jw-theme-effects-shadow-shadow-xxl-box-shadow);color:var(--jw-theme-surface-text-default-color);display:flex;flex-direction:column;pointer-events:none;position:relative;transform:scale(0);transition:box-shadow .2s linear .01s}.content.-anim-open{animation:u7k2cao .5s cubic-bezier(.25,.46,.45,.94) forwards}@keyframes u7k2cao{0%{opacity:0;transform:scale(.8)}90%{opacity:1}to{transform:scale(1)}}.content.-anim-close{animation:u7k2cbi .5s cubic-bezier(.25,.46,.45,.94) forwards}@keyframes u7k2cbi{0%{opacity:1;transform:scale(1)}90%{opacity:0}to{opacity:0;transform:scale(.8)}}.content.-anim-minimize{animation:u7k2cbq .5s cubic-bezier(.23,1,.32,1) forwards}@keyframes u7k2cbq{0%{opacity:0;transform:translate(-8px,-8px);transform-origin:100% 0}to{opacity:1;transform:translate(0);transform-origin:50% 50%}}.content.-anim-minimize-from-max{animation:u7k2cc2 .5s cubic-bezier(.23,1,.32,1) forwards}@keyframes u7k2cc2{0%{transform:scale(1.2)}to{transform:scale(1)}}.content.-anim-maximize{animation:u7k2cc8 .5s cubic-bezier(.23,1,.32,1) forwards;overflow:auto}@keyframes u7k2cc8{0%{transform:scale(.8)}to{transform:scale(1)}}header{align-items:center;display:inline-flex;justify-content:flex-end}header h2{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:1.25rem;font-weight:400;letter-spacing:-.0008em;line-height:1.75rem;margin:0 auto 0 0;word-break:break-word}header[data-header-visible]{padding-bottom:2rem}.description p{font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin:0;max-width:480px;word-break:break-word}.body{display:flex;flex:1;flex-direction:column;gap:1rem}.actions{display:flex;flex:1}:host([size=sm]:not([data-display=mini]):not([data-display=max])) .content{width:var(--jw-container-md)}:host([size=md]:not([data-display=mini]):not([data-display=max])) .content{width:var(--jw-container-xl)}:host([size=lg]:not([data-display=mini]):not([data-display=max])) .content{width:var(--jw-container-2xl)}:host([data-display=open]) .content{pointer-events:all}:host([data-display=max]) .container{padding:0}:host([data-display=max]) .actions,:host([data-display=max]) .body{width:100%}:host([data-display=max]) .actions{flex:0}:host([data-display=max]) .content{border-radius:0;min-height:100vh;min-width:100vw;pointer-events:all}:host([data-display=max]) .content-inner{align-items:center;display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;width:100%}:host([data-display=mini]){pointer-events:none}:host([data-display=mini]) .backdrop{opacity:0;pointer-events:none}:host([data-display=mini]) .content{bottom:1rem;box-shadow:var(--jw-theme-effects-shadow-shadow-lg-box-shadow);flex-direction:row;overflow:hidden;padding:.75rem 1rem;pointer-events:all;position:absolute;right:1rem;transition:min-width .35s ease}:host([data-display=mini]) .content-inner{align-items:center;display:flex;flex-direction:row}:host([data-display=mini]) .body{align-items:center;display:flex;flex:1;flex-direction:row;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;height:100%;letter-spacing:-.0004em;line-height:1.25rem}:host([data-display=mini]) .actions{align-items:center;border:none;display:flex;gap:.5rem;height:100%;white-space:nowrap}:host(:not([data-display=mini])) .body:last-child{margin-bottom:2rem}:host(:not([data-display=mini])) .actions{margin-top:2rem}::slotted([slot]){display:flex;flex:1;flex-direction:column}::slotted([slot=actions]),::slotted([slot=body-mini]){flex-direction:row}::slotted([slot=actions]){gap:.5rem}::slotted([slot=body-mini]){align-items:center;gap:.75rem;margin-right:.75rem;white-space:nowrap}";

const WuiModal$1 = /*@__PURE__*/ proxyCustomElement(class WuiModal extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.displayChanged = createEvent(this, "displayChanged", 3);
        /**
         * Modal header
         */
        this.header = '';
        /**
         * Modal description
         */
        this.description = '';
        /**
         * Modal theme
         */
        this.theme = 'light';
        /**
         * Modal width
         */
        this.size = 'sm';
        /**
         * Whether to show a backdrop behind the modal, overlaying the rest of the viewport.
         */
        this.backdrop = true;
        /**
         * Whether modal can be minimized (by clicking on backdrop or close button).
         */
        this.minimizable = false;
        /**
         * Whether modal can be maximized to fullscreen
         */
        this.maximizable = false;
        /**
         * Whether modal must be explicitly dismissed by an action.
         *
         * A blocking modal will prevent any other page interaction until the modal is dismissed.
         */
        this.blocking = false;
        /**
         * Action to take when clicking backdrop or close button.
         *
         * Defaults to `minimizeOrClose`. This means that it will try
         * to minimize if the modal allows it, else it will close.
         */
        this.dismissAction = 'minimizeOrClose';
        this.contentAnimClass = '';
        this.backdropAnimClass = '';
        this.display = 'closed';
        this.animate = async ({ backdrop, content, }) => {
            const shadowRoot = this.elm.shadowRoot;
            if (!shadowRoot) {
                return;
            }
            // Set waiter before toggling animation class
            const promise = Promise.all([
                backdrop ? waitForAnimation(shadowRoot.querySelector('.backdrop')) : Promise.resolve(),
                content ? waitForAnimation(shadowRoot.querySelector('.content')) : Promise.resolve(),
            ]);
            if (backdrop) {
                this.backdropAnimClass = backdrop;
            }
            if (content) {
                this.contentAnimClass = content;
            }
            await promise;
        };
        this.handleDismiss = () => {
            // Can't dismiss blocking modals
            if (this.blocking) {
                return;
            }
            switch (this.dismissAction) {
                case 'close':
                    this._setDisplay('closed');
                    break;
                case 'minimize':
                    this._setDisplay('mini');
                    break;
                default:
                    if (this.minimizable) {
                        this._setDisplay('mini');
                    }
                    else {
                        this._setDisplay('closed');
                    }
                    break;
            }
        };
        this.oldOverflow = '';
    }
    _display(newValue) {
        if (newValue === 'mini') {
            // If display changes to mini, we want the backdrop to scroll
            document.body.style.overflow = this.oldOverflow;
        }
        else {
            document.body.style.overflow = 'hidden';
        }
    }
    /**
     * Set display state.
     *
     * Possible values: `'open'`, `'closed'`, `'mini', 'max'`.
     */
    async setDisplay(value) {
        if (this.display === value) {
            return;
        }
        return this._setDisplay(value);
    }
    _setDisplay(value) {
        return new Promise((resolve) => {
            window.requestAnimationFrame(() => {
                const isMini = this.display === 'mini';
                const isOpen = this.display === 'open';
                const isClosed = this.display === 'closed';
                const isMax = this.display === 'max';
                switch (value) {
                    case 'open':
                        this.resetMiniActionsStyle();
                        this.animate(isClosed || isMini
                            ? {
                                backdrop: '-anim-fade-in',
                                content: '-anim-open',
                            }
                            : isMax
                                ? {
                                    backdrop: '-anim-fade-in',
                                    content: '-anim-minimize-from-max',
                                }
                                : {}).then(() => {
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        this.display = 'open';
                        break;
                    case 'max':
                        this.animate({
                            backdrop: undefined,
                            content: '-anim-maximize',
                        }).then(() => {
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        this.display = 'max';
                        break;
                    case 'closed':
                        this.animate({
                            backdrop: isMini ? undefined : '-anim-fade-out',
                            content: '-anim-close',
                        }).then(() => {
                            window.requestAnimationFrame(() => {
                                // Wait for animation to finish before persisting value
                                this.display = 'closed';
                                this.displayChanged.emit(this.display);
                                resolve();
                            });
                        });
                        break;
                    case 'mini':
                        this.resetMiniActionsStyle();
                        this.animate({
                            backdrop: isOpen ? '-anim-fade-out' : undefined,
                            content: '-anim-minimize',
                        }).then(() => {
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        this.display = value;
                        break;
                    default:
                        resolve();
                        break;
                }
            });
        });
    }
    resetMiniActionsStyle() {
        const shadowRoot = this.elm.shadowRoot;
        if (!shadowRoot) {
            return;
        }
        const actionsEl = shadowRoot.querySelector('.actions');
        if (!actionsEl) {
            return;
        }
        actionsEl.style.width = '';
        actionsEl.style.opacity = '';
    }
    connectedCallback() {
        if (this.display !== 'mini') {
            this.oldOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
    }
    componentDidLoad() {
        const modalId = this.uid ? `wui_modal__${this.uid}` : '';
        const modal = document.getElementById(modalId);
        modal?.focus();
    }
    disconnectedCallback() {
        document.body.style.overflow = this.oldOverflow;
    }
    render() {
        const { header, description, backdrop, blocking, display, theme, uid, maximizable, minimizable, contentAnimClass, backdropAnimClass, } = this;
        const hasTitle = header && display !== 'mini';
        const isMaximizable = maximizable && display !== 'mini';
        const isMinimizable = minimizable && display !== 'mini';
        const showCloseButton = !blocking && !maximizable && !minimizable && display === 'open';
        return (h(Host, { key: '09155784b520d1e9c3ca07ebaf6bdde41bd1f70f', id: uid ? `wui_modal__${uid}` : '', "data-display": display, theme: theme, tabIndex: -1 }, backdrop && h("div", { key: '4e7e7cef53e782cd377227fa8fe6866c2e5cf0ee', class: `backdrop ${backdropAnimClass}`, role: "button", onClick: this.handleDismiss }), h("div", { key: '0499548a440a71ae1ba10c3d978bb4625944b112', class: "container" }, h("div", { key: '4266dc36961bba549071caf8b36097c35c50310c', class: `content ${contentAnimClass}` }, h("header", { key: '2dd82613217ffccfd9ca005f7bfbb50687e98d2e', "data-header-visible": hasTitle || showCloseButton || isMaximizable || isMinimizable }, hasTitle && h("h2", { key: 'e98ab4b223fc656c026b1bbdf4ac97f7c2d362de' }, header), showCloseButton && h("wui-close-button", { key: 'e215a79a7747444af363329bd5e8fcaf3833b474', onClick: this.handleDismiss }), isMaximizable && (h("wui-button", { key: '3b6a962e2f7106bda1f2259653453c308627461a', type: "icon-ghost", icon: display === 'open' ? 'arrows-diagonal' : 'arrows-diagonal-minimize', onClick: () => this.setDisplay(display === 'max' ? 'open' : 'max'), tooltip: display === 'open' ? 'Maximize' : 'Minimize' })), isMinimizable && (h("wui-button", { key: '64704f30fead88b251b2420e6b913b2665ce92a9', type: "icon-ghost", icon: "arrows-diagonal-minimize", tooltip: "Minimize", onClick: () => this.setDisplay('mini') }))), h("div", { key: '25676a9ad52e52fc4d61c212b2de6b15beba8df0', class: "content-inner" }, description && display !== 'mini' && (h("div", { key: '1f5785d2b139163a8ef99bf579b6ff01640b6f44', class: "description" }, description && h("p", { key: 'c9ca061bb3f07ecd9a38b8d4d33baef53e996308' }, description))), h("div", { key: 'bcbccd1126933c67ded7f503d3eddebfd434f768', class: "body" }, display === 'mini' ? h("slot", { name: "body-mini" }) : h("slot", { name: "body" })), h("div", { key: '1a3ec42bc4ed45132f733dbed9e2dbc22f98ee7b', class: "actions" }, display === 'mini' ? h("slot", { name: "actions-mini" }) : h("slot", { name: "actions" }), !blocking && display === 'mini' && h("wui-close-button", { key: '8a95dd53e58eafc14c6d20dfc8f8ded23bf2cf50', onClick: this.handleDismiss })))))));
    }
    get elm() { return this; }
    static get watchers() { return {
        "display": ["_display"]
    }; }
    static get style() { return modalCss; }
}, [257, "wui-modal", {
        "uid": [1],
        "api": [16],
        "header": [1],
        "description": [1],
        "theme": [513],
        "size": [513],
        "backdrop": [4],
        "minimizable": [4],
        "maximizable": [4],
        "blocking": [4],
        "dismissAction": [1, "dismiss-action"],
        "contentAnimClass": [32],
        "backdropAnimClass": [32],
        "display": [32],
        "setDisplay": [64]
    }, undefined, {
        "display": ["_display"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-modal", "wui-button", "wui-close-button", "wui-icon", "wui-loader", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-modal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiModal$1);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiModal = WuiModal$1;
const defineCustomElement = defineCustomElement$1;

export { WuiModal, defineCustomElement };
